// Models
export var PlannerChatThreadType;
(function(PlannerChatThreadType) {
    /** The thread for task chat */ PlannerChatThreadType["Task"] = "task";
    /** The thread for plan chat */ PlannerChatThreadType["Plan"] = "plan";
})(PlannerChatThreadType || (PlannerChatThreadType = {}));
export var ChatMentionType;
(function(ChatMentionType) {
    ChatMentionType["User"] = "user";
    ChatMentionType["Application"] = "application";
})(ChatMentionType || (ChatMentionType = {}));
export var ChatMessageType;
(function(ChatMessageType) {
    ChatMessageType["RichText"] = "richTextHtml";
    ChatMessageType["Text"] = "plainText";
})(ChatMessageType || (ChatMessageType = {}));
